<div *ngIf="(OrganizationData != null && OrganizationData.length > 2) || (yearData != null && yearData.length > 2) || (monthData != null && monthData.length > 2 && organizationMonth)" [@loadedFadeAnimation]="'visible'" class="filters">
  <!-- <div><strong>Filtros</strong></div> -->
  <div class="row">
    <div *ngIf="OrganizationData != null && OrganizationData.length > 2" [@loadedFadeAnimation]="'visible'" class="col-md-3">
      <select2 [data]="OrganizationData" (update)="onChangeOrganization($event)" [placeholder]="'Seleccionar categoría'" [(ngModel)]="idOrganizationFilter"></select2>
    </div>
    <div *ngIf="yearData != null && yearData.length > 2" [@loadedFadeAnimation]="'visible'" class="col-md-3">
      <select2 [data]="yearData" (update)="onChangeYear($event)" [placeholder]="'Ano'" [(ngModel)]="idYearFilter"></select2>
    </div>
    <div *ngIf="monthData != null && monthData.length > 2 && organizationMonth" [@loadedFadeAnimation]="'visible'" class="col-md-3">
      <select2 [data]="monthData" [placeholder]="'Mês'" [(ngModel)]="idMonthFilter"></select2>
    </div>
    <div class="col-auto">
      <button class="btn-search" type="button" (click)="rerender()"><fa-icon [icon]="['fas','search']" class="fa-lg"></fa-icon><span class="visually-hidden">Pesquisar</span></button>
    </div>
  </div>
</div>

<div class="table-responsive-sm fadein-table">
  <table id="tblDocuments" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table data-tables dataTable no-footer">
    <thead>
      <tr>
        <th class="w-6">&nbsp;</th>
        <th class="w-8">Imagem</th>
        <th class="w-14">Área</th>
        <th class="w-8">Data</th>
        <th>Documento</th>
        <th class="w-8 text-center">Formato</th>
        <th class="w-10 text-center">Opções</th>
      </tr>
    </thead>
  </table>
</div>
<div *ngIf="showProgress">
  <app-progress-bar [progress]="progress"></app-progress-bar>
</div>